import { render, staticRenderFns } from "./NovoPrestado.vue?vue&type=template&id=1ece967c"
import script from "./NovoPrestado.vue?vue&type=script&lang=js"
export * from "./NovoPrestado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports